import {wxLogin} from "./api";

export default {
    getUrlParam(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        console.log(r);
        if (r != null) return unescape(r[2]);
        return null;
    },
    getCode() {

        // 非静默授权，第一次有弹框
        // const code = "29571";
        const code =  this.getUrlParam("code"); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
        const local = window.location.href;

       // alert('local:'+local);
        const APPID = "ww61845d6b2e7a4ad2"; // 企业微信
        this.code = code;
        if (code == null || code == "") {
            window.location.href =
                "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
                APPID +
                "&redirect_uri=" +
                encodeURIComponent(local) +
                "&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect";
        } else {
            return this.getOpenId(code); //把code传给后台获取用户信息

        }
    },
    getOpenId(code,id) {
        // 通过code获取 用户信息，/api/wxuserauth为后台接口
        console.log(code);
        return wxLogin(code);

    }
}